import { TOAST_LIFETIME } from '@/constants';
import type { ToastMessageOptions } from 'primevue/toast';
import { useToast } from 'primevue/usetoast';

export const useLaunchToast = () => {
    const toast = useToast();
    return (
            severity: ToastMessageOptions['severity'],
            summary: string,
            detail?: string,
            life?: number | null | 'sticky',
            options?: ToastMessageOptions
        ) =>
        (...args: unknown[]) => {
            if (severity === 'error' && args.length > 0) {
                console.error('Error:', args);
            }
            toast.add({
                severity,
                summary,
                detail,
                life: life === 'sticky' ? undefined : life || TOAST_LIFETIME,
                ...options,
            });
        };
};
